import { t } from 'i18next';
import { CustomButton } from '../elements/button';
import { useEffect, useState } from 'react';

export const SaveAppToPhoneButton = () => {
  let showSaveAppButton = false;

  //Check device type and which browser
  const userAgent = navigator.userAgent.toLowerCase();
  const isAndroid = userAgent.includes('android');
  const isUnSupportedBrowser =
    (userAgent.includes('safari') || userAgent.includes('firefox')) &&
    !userAgent.includes('chrome');

  if (isAndroid || !isUnSupportedBrowser) {
    showSaveAppButton = true;
  }

  const handleCreateShortcut = async () => {
    const promptEvent = window.deferredPrompt;

    if (!promptEvent) {
      return;
    }

    promptEvent.prompt();

    const result = await promptEvent.userChoice;

    window.deferredPrompt = null;
  };

  return showSaveAppButton ? (
    <CustomButton
      style={{
        mb: '28px',
        color: 'rgb(10, 10, 10)',
        border: '1.7px solid rgb(10, 10, 10)',
        background: '#D2FF28',
        boxShadow: '0px 0px 0px 8px #D2FF28',
        '&:hover': {
          background: '#D2FF28',
          border: '1.5px solid rgb(16, 16, 13)',
        },
        '&:focus': {
          border: '1px solid rgb(10, 10, 10)',
        },
      }}
      title={t('common.label.saveAppToPhone', { ns: 'common' })}
      onClick={handleCreateShortcut}
    ></CustomButton>
  ) : (
    <></>
  );
};
